import clsx from 'clsx';

export const AmountStepper: React.FC<{
  currentAmount: string | number;
  onClickMore: () => void;
  onClickLess: () => void;
  size?: 'small' | 'normal';
}> = ({ currentAmount, onClickMore, onClickLess, size = 'normal' }) => {
  return (
    <div className="flex border rounded-md shadow-md border-primary-20">
      <div
        className={clsx(
          'h-full flex items-center justify-center bg-[#03335426] rounded-l-md font-medium select-none',
          size === 'small'
            ? 'min-h-[38px] w-[26px] md:min-h-[28px] md:w-[30px] '
            : 'min-h-[38px] w-[26px] md:min-h-[54px] md:w-[43px] '
        )}
        onClick={onClickLess}
        role="button"
      >
        -
      </div>
      <div
        className={clsx(
          ' flex items-center justify-center bg-primary-contrast text-primary font-semibold',
          size === 'small'
            ? 'w-8 h-full min-h-[38px] md:min-h-[28px] md:w-[30px] '
            : 'w-8 h-full min-h-[38px] md:min-h-[54px] md:w-[43px] '
        )}
      >
        {currentAmount}
      </div>
      <div
        className={clsx(
          'h-full flex items-center justify-center bg-[#03335426] rounded-r-md font-medium select-none',
          size === 'small'
            ? 'min-h-[38px] w-[26px] md:min-h-[28px] md:w-[30px] '
            : 'min-h-[38px] w-[26px] md:min-h-[54px] md:w-[43px] '
        )}
        role="button"
        onClick={onClickMore}
      >
        +
      </div>
    </div>
  );
};
